import { AssemblyLayout } from 'src/components/assemblyLayout';
import { AssemblyScreen } from 'src/components/assemblyScreen';
import { AssemblyScreenSection } from 'src/components/assemblyScreenSection';
import { DynamicTooltipChip } from 'src/components/dynamicTooltipChip/DynamicTooltipChip';
import { CustomTooltip } from 'src/components/tooltip/CustomTooltip';

import { LayoutCardProps } from './LayoutCard.interface';
import {
  AssemblyContainer,
  ChipContainer,
  NameContainer,
  Text,
} from './LayoutCard.styled';

export const LayoutCard = (props: LayoutCardProps) => {
  return (
    <AssemblyContainer $isSelected={props.isSelected} onClick={props.onClicked}>
      <AssemblyLayout>
        {props.layout.screens.map((screen, index) => (
          <AssemblyScreen
            key={screen.name + index}
            height={screen.height}
            width={screen.width}
            scale={0.1}
            selectable={false}
            type="screen">
            {screen.sections.map((section, index) => (
              <AssemblyScreenSection
                key={section.name + index}
                section={section}
                scale={0.1}
                selectable={false}
                showEditIcon={false}
              />
            ))}
          </AssemblyScreen>
        ))}
      </AssemblyLayout>

      <ChipContainer>
        {props.layout.config?.sectionTypes?.map((sectionType) => (
          <DynamicTooltipChip chipName={sectionType} />
        ))}
      </ChipContainer>

      <NameContainer>
        <CustomTooltip width={500} placement="bottom" title={props.layout.name}>
          <Text>{props.layout.name}</Text>
        </CustomTooltip>
      </NameContainer>
    </AssemblyContainer>
  );
};
